import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getDataWithTypeForSelect } from "../../../lib/parameters";
import { addData, updateData, getIdData } from "../../../lib/resourcecenter";
import { useAuth } from "../../../usercontext";

function GlobalResourceEdit() {
    const [rdate, setRdate] = useState("");
    const [topic, setTopic] = useState("");
    const [parameters, setParameters] = useState([]);
    const [grade, setGrade] = useState("");
    const [howuse, setHowuse] = useState("");
    const [link1, setLink1] = useState("");
    const [shareWithStudents, setShareWithStudents] = useState(false);
    const [recId, setRecId] = useState(0);
    const [showMessage, setShowMessage] = useState(false);
    const { profile } = useAuth();
    const navigate = useNavigate();
    const { id, slug, status } = useParams();

    const instructorId = profile.id;

    const GetParameterData = async () => {
        const info = await getDataWithTypeForSelect("RESOURCE");
        setParameters(info);
    };

    const getCurrentDateInput = () => {
        const dateObj = new Date();

        // get the month in this format of 04, the same for months
        const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
        const day = ("0" + dateObj.getDate()).slice(-2);
        const year = dateObj.getFullYear();

        const shortDate = `${year}-${month}-${day}`;

        setRdate(shortDate);
    };

    const GetResourceData = async (id) => {
        try {
            if (id) {
                const data = await getIdData(id);
                console.log("Fetched data:", data); // Debug için
                if (data.length > 0) {
                    setRecId(data[0].id);
                    setRdate(data[0].rdate);
                    setTopic(data[0].topic);
                    setGrade(data[0].grade);
                    setHowuse(data[0].howuse);
                    setLink1(data[0].link1);
                } else getCurrentDateInput();
            }
        } catch (error) {
            console.error("Error fetching resource data:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("recId", recId);

        try {
            if (recId > 0) {
                await updateData({
                    id: recId,
                    instructorId: instructorId,
                    rdate: new Date(rdate),
                    topic: topic,
                    grade: grade,
                    howuse: howuse,
                    link1: link1,
                });
            } else {
                await addData({
                    instructorId: instructorId,
                    rdate: new Date(rdate),
                    topic: topic,
                    grade: grade,
                    howuse: howuse,
                    link1: link1,
                });
            }
            setShowMessage(true);
            navigate(`/instructor/instructor-studentresource/${slug}`);
        } catch (error) {
            console.error("Error submitting form:", error.message);
        }
    };

    useEffect(() => {
        GetParameterData();
        if (id) {
            GetResourceData(id);
        }
    }, [id]);

    return (
        <div className="container mt-5">
            {showMessage && (
                <div
                    className="alert alert-success alert-dismissible fade show"
                    role="alert"
                >
                    <strong>Updated!</strong> Your information.
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                    ></button>
                </div>
            )}
            <h1 className="text-center mb-4">Resource Form</h1>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="rdate" className="form-label">
                        Date
                    </label>
                    <input
                        type="date"
                        className="form-control"
                        id="rdate"
                        value={rdate}
                        onChange={(e) => setRdate(e.target.value)}
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="topic" className="form-label">
                        Topic
                    </label>
                    <select
                        className="form-control"
                        id="topic"
                        value={topic}
                        onChange={(e) => setTopic(e.target.value)}
                    >
                        <option value="">Select</option>
                        {parameters.map((param) => (
                            <option key={param.value} value={param.value}>
                                {param.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="mb-3">
                    <label htmlFor="grade" className="form-label">
                        Grade
                    </label>
                    <select
                        className="form-control"
                        id="grade"
                        value={grade}
                        onChange={(e) => setGrade(e.target.value)}
                    >
                        <option value="">Select</option>
                        <option value="12">12</option>
                        <option value="9-11">9-11</option>
                        <option value="All">All</option>
                    </select>
                </div>
                <div className="mb-3">
                    <label htmlFor="howuse" className="form-label">
                        How to use it
                    </label>
                    <textarea
                        className="form-control"
                        id="howuse"
                        value={howuse}
                        onChange={(e) => setHowuse(e.target.value)}
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="link1" className="form-label">
                        Link-1
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        id="link1"
                        value={link1}
                        onChange={(e) => setLink1(e.target.value)}
                    />
                </div>
                <div className="mb-3 form-check">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="shareWithStudents"
                        checked={shareWithStudents}
                        onChange={(e) => setShareWithStudents(e.target.checked)}
                    />
                    <label
                        className="form-check-label"
                        htmlFor="shareWithStudents"
                    >
                        Share with my students
                    </label>
                </div>
                <div className="update-profile d-flex justify-content-between">
                    <button type="submit" className="btn btn-primary">
                        {status === "Add" ? "Add Resource" : "Update Resource"}
                    </button>
                    <button
                        type="button"
                        className="btn btn-black btn-sm"
                        onClick={() => navigate(-1)}
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
}

export default GlobalResourceEdit;
